__turbopack_context__.v({
  "active": "Header-module-scss-module__OpyoxG__active",
  "activity_nav_dropdown": "Header-module-scss-module__OpyoxG__activity_nav_dropdown",
  "activity_nav_items": "Header-module-scss-module__OpyoxG__activity_nav_items",
  "groups_nav_items": "Header-module-scss-module__OpyoxG__groups_nav_items",
  "grouptour_nav_dropdown": "Header-module-scss-module__OpyoxG__grouptour_nav_dropdown",
  "have_submenu_items_list": "Header-module-scss-module__OpyoxG__have_submenu_items_list",
  "header_bottom": "Header-module-scss-module__OpyoxG__header_bottom",
  "header_flex": "Header-module-scss-module__OpyoxG__header_flex",
  "header_right": "Header-module-scss-module__OpyoxG__header_right",
  "header_right_btn": "Header-module-scss-module__OpyoxG__header_right_btn",
  "header_toggle": "Header-module-scss-module__OpyoxG__header_toggle",
  "header_top": "Header-module-scss-module__OpyoxG__header_top",
  "header_top_center": "Header-module-scss-module__OpyoxG__header_top_center",
  "header_top_left": "Header-module-scss-module__OpyoxG__header_top_left",
  "header_top_main": "Header-module-scss-module__OpyoxG__header_top_main",
  "header_top_right": "Header-module-scss-module__OpyoxG__header_top_right",
  "img_box": "Header-module-scss-module__OpyoxG__img_box",
  "mobile_call": "Header-module-scss-module__OpyoxG__mobile_call",
  "mobile_header": "Header-module-scss-module__OpyoxG__mobile_header",
  "mobile_header_cont": "Header-module-scss-module__OpyoxG__mobile_header_cont",
  "mobile_header_div": "Header-module-scss-module__OpyoxG__mobile_header_div",
  "mobile_header_links": "Header-module-scss-module__OpyoxG__mobile_header_links",
  "mobile_view_lists": "Header-module-scss-module__OpyoxG__mobile_view_lists",
  "mobile_view_lists_item": "Header-module-scss-module__OpyoxG__mobile_view_lists_item",
  "mobile_view_lists_subitem": "Header-module-scss-module__OpyoxG__mobile_view_lists_subitem",
  "mobile_view_lists_submenus_ul": "Header-module-scss-module__OpyoxG__mobile_view_lists_submenus_ul",
  "mobile_view_ul": "Header-module-scss-module__OpyoxG__mobile_view_ul",
  "nav_item": "Header-module-scss-module__OpyoxG__nav_item",
  "nav_link": "Header-module-scss-module__OpyoxG__nav_link",
  "navbar_cut_btn": "Header-module-scss-module__OpyoxG__navbar_cut_btn",
  "res_header_links": "Header-module-scss-module__OpyoxG__res_header_links",
  "scrolled_header": "Header-module-scss-module__OpyoxG__scrolled_header",
  "secoundary_btn": "Header-module-scss-module__OpyoxG__secoundary_btn",
  "stay_nav_dropdown": "Header-module-scss-module__OpyoxG__stay_nav_dropdown",
  "stay_nav_items": "Header-module-scss-module__OpyoxG__stay_nav_items",
  "stay_nav_items_child": "Header-module-scss-module__OpyoxG__stay_nav_items_child",
  "toogle_btn": "Header-module-scss-module__OpyoxG__toogle_btn",
  "top_call_icon": "Header-module-scss-module__OpyoxG__top_call_icon",
  "top_logo": "Header-module-scss-module__OpyoxG__top_logo",
});
